import { useLocation } from 'react-router-dom';

export default function TestHistoryPage() {
    const location = useLocation();

    const diagnosisList = location.state?.diagnosisList;

    console.log('diagnosisList:: ', diagnosisList);
    return <div>TestHistoryPage</div>;
}
